// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_containers_pgmpartner {
  overflow: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.details_containers_pgmpartner::-webkit-scrollbar {
  width: 0px;
}
.details_containers_pgmpartner::-webkit-scrollbar-thumb {
  background: transparent;
}
.details_containers_pgmpartner .partnerContainer {
  width: 100%;
  display: flex;
}
.details_containers_pgmpartner .partnerContainerleft {
  width: 20%;
}
.details_containers_pgmpartner .pgmlist_buttons_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  border-bottom: 0px;
}
.details_containers_pgmpartner .partnerContainerright {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.details_containers_pgmpartner .partnerContainerright::-webkit-scrollbar {
  width: 0px;
}
.details_containers_pgmpartner .partnerContainerright::-webkit-scrollbar-thumb {
  background: transparent;
}
.details_containers_pgmpartner .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.details_containers_pgmpartner .header_border > img {
  margin: 0.9rem 1rem;
}
.details_containers_pgmpartner .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.details_containers_pgmpartner .pgmlist_buttons {
  display: flex;
  width: 98%;
  margin: 1rem auto;
  gap: 1rem;
  border-bottom: 1px solid #c1c6d0;
}
.details_containers_pgmpartner .Pgmlist_pending {
  width: 15%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0c3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #ffffff;
}
.details_containers_pgmpartner .pgmlist_Approved {
  width: 15%;
  height: 40px;
  background: #e5f0ff;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7c87a1;
  border: none;
}
.details_containers_pgmpartner .pgmlist_Add {
  width: 15%;
  height: 40px;
  background: #e5f0ff;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7c87a1;
  border: none;
}
.details_containers_pgmpartner .Partner_para_four_span {
  width: 29px;
  height: 29px;
  background: #1445a4;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmpartner .security-container {
  text-align: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmpartner .security-line {
  width: 100%;
  margin: 10px 0;
  border-top: 1px solid #BCC6D7;
}
.details_containers_pgmpartner .security-text {
  background-color: #fff;
  padding: 0 10px;
  color: #52443B;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1000000015px;
  text-align: center;
  white-space: nowrap;
}
.details_containers_pgmpartner .personalino-container {
  text-align: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmpartner .personalino-line {
  width: 100%;
  margin: 10px 0;
  border-top: 1px solid #BCC6D7;
}
.details_containers_pgmpartner .personalino-text {
  background-color: #fff;
  padding: 0 10px;
  color: #52443B;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1000000015px;
  text-align: center;
  white-space: nowrap;
}
.details_containers_pgmpartner .Partner_para_four_paragraphs {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #9CA8C0;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0rem;
}
.details_containers_pgmpartner .Partner_para_four_spans {
  width: 29px;
  height: 29px;
  background: #9CA8C0;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmpartner .Partner_para_four_paragraph {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0rem;
}
.details_containers_pgmpartner .Partner_para_fours_child {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.details_containers_pgmpartner .activeAddnew {
  width: fit-content;
  left: 299px;
  top: 122px;
  background: #0C3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  border: none;
  color: #ffffff;
  text-decoration: none;
  white-space: nowrap;
}
.details_containers_pgmpartner .Partner_para_four {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
  width: 98%;
  background: #eff6ff;
  align-items: center;
  text-align: center;
  padding: 0.8rem 0rem;
}
.details_containers_pgmpartner .Partner_para_fours {
  display: flex;
  gap: 50px;
  align-items: center;
  text-align: center;
  padding: 0rem 0.4rem;
}
.details_containers_pgmpartner p {
  background: none;
}
.details_containers_pgmpartner .personal_information {
  width: 98%;
  margin: 1rem;
}
.details_containers_pgmpartner .personal_information > img {
  width: 95%;
  margin: 1rem;
}
.details_containers_pgmpartner .personal_info_container {
  width: 98%;
  margin: auto;
  display: flex;
  margin-bottom: 1rem;
}
.details_containers_pgmpartner .personal_info_left {
  width: 15%;
  display: flex;
  justify-content: center;
  margin: 1rem 0rem;
  padding: 1rem 0rem;
}
.details_containers_pgmpartner .personal_info_right {
  width: 85%;
}
.details_containers_pgmpartner .loginthirdpara {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33%;
}
.details_containers_pgmpartner .personal_inforight_security {
  display: flex;
  gap: 20px;
}
.details_containers_pgmpartner .personal_inforight_security .loginthirdpara-security {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
}
.details_containers_pgmpartner .personal_inforight_security .loginthirdpara-security .security-input-select {
  width: 100% !important;
}
.details_containers_pgmpartner .input-wrapper {
  position: relative;
  width: 100%;
}
.details_containers_pgmpartner .input-wrapper .error-text {
  color: red;
}
.details_containers_pgmpartner .input-wrapper-addpartner-answers {
  position: relative;
  width: 100%;
}
.details_containers_pgmpartner .profile-plus-icons {
  margin: 0rem 2rem;
  position: relative;
  z-index: 2;
  top: -1rem;
}
.details_containers_pgmpartner .phonenumber::placeholder {
  margin: 0rem 1rem !important;
}
.details_containers_pgmpartner .phonenumber {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 98%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner #message {
  text-align: left;
  margin-left: 15px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: red;
  max-width: 250px;
}
.details_containers_pgmpartner .react-tel-input .country-list {
  margin: 10px 0 10px -15px;
}
.details_containers_pgmpartner .select-group {
  width: 100% !important;
}
.details_containers_pgmpartner input, .details_containers_pgmpartner .select-group {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  width: 100%;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner .phone_input {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.details_containers_pgmpartner .number_inp {
  border: none;
  height: 3rem;
  outline: none;
  padding: 0;
  margin-left: 13px;
  width: 100%;
}
.details_containers_pgmpartner .react-tel-input .form-control {
  border-radius: 6px;
  position: relative;
  width: 60px;
  height: 3.3rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
  color: #10132e;
  cursor: pointer;
  border: none;
  background-color: white;
}
.details_containers_pgmpartner .phone_bar {
  margin-left: 23px;
  margin-bottom: 3px;
  font-size: 19px;
}
.details_containers_pgmpartner .react-tel-input .flag-dropdown {
  border-right: none !important;
  background-color: white;
  border: none !important;
  height: 3.3rem;
}
.details_containers_pgmpartner .react-tel-input .selected-flag {
  width: 17px !important;
  padding: 0 !important;
}
.details_containers_pgmpartner .react-tel-input .selected-flag .arrow {
  display: none;
}
.details_containers_pgmpartner .react-tel-input {
  border-radius: 6px;
  position: relative;
  width: 45px;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner .input_textarea {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 98%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner .pass-icon {
  position: absolute;
  top: 25%;
  right: 10px;
  color: #0C3688;
  cursor: pointer;
}
.details_containers_pgmpartner .date-icon {
  position: relative;
  z-index: 2;
  top: -2.8rem;
  left: -2rem;
  display: flex;
  justify-content: end;
  float: right !important;
  cursor: pointer;
}
.details_containers_pgmpartner .phone-icons {
  position: relative;
  z-index: 2;
  top: 3.2rem;
  left: 0rem;
  display: flex;
  justify-content: end;
  cursor: pointer;
  float: right;
}
.details_containers_pgmpartner .enroll_select {
  position: absolute;
  top: 0px;
  z-index: 99;
  left: 1.6em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.details_containers_pgmpartner label {
  position: absolute;
  top: -10px;
  z-index: 99;
  left: 1.6em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.details_containers_pgmpartner .select-wrapper {
  position: relative;
  display: block;
}
.details_containers_pgmpartner .partners_five_para {
  width: 98%;
  margin: 1rem auto;
}
.details_containers_pgmpartner select {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  margin: 0px !important;
  line-height: 6ex;
  width: 100%;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner .details_containers_pgmpartner select {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 100%;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmpartner .multiselect_partner {
  width: 100%;
}
.details_containers_pgmpartner .multiselect_partner fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}
.details_containers_pgmpartner .multiple_select {
  height: 54.4px;
}
.details_containers_pgmpartner .multiselect_input {
  min-width: 80% !important;
}
.details_containers_pgmpartner .personal_inforight_inside {
  display: flex;
  margin-top: 1.5rem;
  align-items: center;
  gap: 1rem;
}
.details_containers_pgmpartner .Button_nexts .button_nextPartner {
  width: 16%;
  height: 40px;
  background: #0c3688;
  box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);
  border-radius: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #ffffff;
  border: none;
  margin: 1rem 2rem;
  margin-bottom: 4rem;
}
.details_containers_pgmpartner .button_nextPartner:disabled {
  width: 16%;
  height: 40px;
  background: #4d6698;
  box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);
  border-radius: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #ffffff;
  border: none;
  margin: 1rem;
  margin-bottom: 4rem;
}
.details_containers_pgmpartner .user-profile {
  cursor: cell;
}
.details_containers_pgmpartner .Securityquestion_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin: 1rem 2rem;
  color: #32363f;
}
.details_containers_pgmpartner .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.details_containers_pgmpartner .personal_inforight_inside_next {
  justify-content: flex-start;
  align-items: center;
}

.pass-flex {
  display: flex;
  width: 50%;
  gap: 20px;
}

@media screen and (max-width: 768px) {
  .details_containers_pgmpartner .partnerContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .pass-flex {
    display: flex;
    width: 100%;
  }
  .details_containers_pgmpartner .personal_inforight_security .loginthirdpara-security {
    width: 100%;
  }
  .personal_inforight_security {
    flex-direction: column;
  }
  .loginthirdpara {
    width: 100% !important;
  }
  .personal_info_right {
    width: 98% !important;
  }
  .details_containers_pgmpartner .partnerContainerleft {
    width: 100%;
  }
  .partnerContainerright {
    width: 100% !important;
    overflow-y: scroll !important;
    overflow-x: hidden !important;
    height: 100% !important;
  }
  .details_containers_pgmpartner {
    overflow: scroll;
    height: 100vh;
  }
  .details_containers_pgmpartner .pgmlist_buttons {
    display: flex;
    width: 95%;
    margin: 1rem;
    flex-wrap: wrap;
    gap: 1rem;
    border-bottom: 1px solid #c1c6d0;
  }
  .details_containers_pgmpartner .activeAddnew {
    width: 100%;
    height: 40px;
    left: 299px;
    top: 122px;
    background: #0C3688;
    border-radius: 8px 8px 0px 0px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    border: none;
    color: #ffffff;
    text-decoration: none;
  }
  .details_containers_pgmpartner .Partner_para_fours {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    padding: 0rem 0.4rem;
    gap: 1rem;
  }
  .details_containers_pgmpartner .personal_info_container {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
  .details_containers_pgmpartner .personal_info_left {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .details_containers_pgmpartner .personal_inforight_inside {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    align-items: start;
  }
  .details_containers_pgmpartner .input-wrapper-addpartner-answers {
    position: relative;
  }
  .personal_inforight_inside_next {
    justify-content: center !important;
  }
  .partnerContainer {
    display: flex;
    flex-direction: column;
  }
  .partnerContainerleft {
    width: 100% !important;
  }
  .partnerContainerright {
    width: 100% !important;
  }
  .pgmlistmain {
    width: 100% !important;
    height: 100vh;
    background: #ffffff;
  }
  .pgmlist_container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .pgmlist_buttons_container .pgmlist_buttons .pgmlist_Approved, .activeAddnew {
    width: 46% !important;
  }
  .activeAddnew {
    width: 46% !important;
  }
}
@media screen and (max-width: 1024px) and (min-width: 481px) {
  .details_containers_pgmpartner .personal_inforight_inside {
    display: flex;
    margin-top: 1rem;
    align-items: center;
    gap: 1rem;
  }
  .details_containers_pgmpartner .personal_inforight_inside .loginthirdpara {
    width: 45%;
  }
  .Partner_para_fours {
    width: 95% !important;
  }
}
@media screen and (max-width: 480px) {
  .personal_inforight_inside {
    flex-wrap: wrap;
  }
  .pass-flex {
    flex-direction: column;
  }
  .button_nextPartner {
    width: 90% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Partner/partner.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AARF;AAAE;EACE,UAAA;AAEJ;AACE;EACE,uBAAA;AACJ;AAIE;EACE,WAAA;EACA,aAAA;AAFJ;AAKE;EACE,UAAA;AAHJ;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAOA,qBAAA;AAXJ;AAKI;EACE,UAAA;AAHN;AAKI;EACE,uBAAA;AAHN;AAQE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AANJ;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AARJ;AAWE;EACE,aAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gCAAA;AATJ;AAYE;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAVJ;AAaE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAXJ;AAcE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAZJ;AAeE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAbJ;AAeE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,cAAA;EACA,6BAAA;AAdJ;AAiBE;EACE,sBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAfJ;AAiBE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,cAAA;EACA,6BAAA;AAhBJ;AAmBE;EACE,sBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAnBJ;AAsBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AApBJ;AAuBE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAxBJ;AA2BE;EACE,gBAAA;AAzBJ;AA4BE;EACE,UAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,UAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AA7BJ;AAgCE;EACE,UAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,SAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAhCN;AAkCM;EACE,sBAAA;AAhCR;AAqCE;EACE,kBAAA;EACA,WAAA;AAnCJ;AAqCI;EACE,UAAA;AAnCN;AAuCE;EACE,kBAAA;EACA,WAAA;AArCJ;AAwCE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAtCJ;AAyCE;EACE,4BAAA;AAvCJ;AA0CE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAxCJ;AA0CG;EACC,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AAxCJ;AA0CE;EACE,yBAAA;AAxCJ;AA2CA;EACE,sBAAA;AAzCF;AA4CE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA1CJ;AA6CE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA3CJ;AA8CE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AA7CJ;AAgDE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AA9CJ;AAiDE;EACE,6BAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;AA/CJ;AAkDE;EACE,sBAAA;EACA,qBAAA;AAhDJ;AAmDE;EACE,aAAA;AAjDJ;AAoDE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAlDJ;AAqDE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAnDJ;AAsDE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AApDJ;AAuDE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;AArDJ;AAwDE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;AAtDJ;AAyDE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvDJ;AA0DE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAxDJ;AA2DE;EACE,kBAAA;EACA,cAAA;AAzDJ;AA4DE;EACE,UAAA;EACA,iBAAA;AA1DJ;AA6DE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA3DJ;AA8DE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA5DJ;AA+DE;EACE,WAAA;AA7DJ;AAgEE;EACE,yBAAA;EACA,kBAAA;AA9DJ;AAiEE;EACE,cAAA;AA/DJ;AAkEE;EACE,yBAAA;AAhEJ;AAmEE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AAjEJ;AAoEE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAlEJ;AAqEE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAnEJ;AAsEE;EACE,YAAA;AApEJ;AAuEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArEJ;AAwEE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAtEJ;AAyEE;EACE,2BAAA;EACA,mBAAA;AAvEJ;;AA4EA;EACE,aAAA;EACA,UAAA;EACA,SAAA;AAzEF;;AA6EA;EACE;IACE,WAAA;IACA,aAAA;IACA,sBAAA;EA1EF;EA6EA;IACE,aAAA;IACA,WAAA;EA3EF;EA8EA;IACE,WAAA;EA5EF;EA+EA;IACE,sBAAA;EA7EF;EAgFA;IACE,sBAAA;EA9EF;EAiFA;IACE,qBAAA;EA/EF;EAkFA;IACE,WAAA;EAhFF;EAmFA;IACE,sBAAA;IACA,6BAAA;IACA,6BAAA;IACA,uBAAA;EAjFF;EAoFA;IACE,gBAAA;IACA,aAAA;EAlFF;EAqFA;IACE,aAAA;IACA,UAAA;IACA,YAAA;IACA,eAAA;IACA,SAAA;IACA,gCAAA;EAnFF;EAsFA;IACE,WAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,mBAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;IACA,qBAAA;EApFF;EAuFA;IACE,aAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,oBAAA;IACA,SAAA;EArFF;EAwFA;IACE,WAAA;IACA,sBAAA;IACA,mBAAA;EAtFF;EAyFA;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAvFF;EA0FA;IACE,aAAA;IACA,uBAAA;IACA,gBAAA;IAEA,kBAAA;EAzFF;EA4FA;IACE,kBAAA;EA1FF;EA6FA;IACE,kCAAA;EA3FF;EA8FA;IACE,aAAA;IACA,sBAAA;EA5FF;EA+FA;IACE,sBAAA;EA7FF;EAgGA;IACE,sBAAA;EA9FF;EAkGA;IACE,sBAAA;IACA,aAAA;IACA,mBAAA;EAhGF;EAmGA;IACE,WAAA;IACA,aAAA;IACA,sBAAA;EAjGF;EAoGA;IACE,qBAAA;EAlGF;EAqGA;IACE,qBAAA;EAnGF;AACF;AAsGA;EACE;IACE,aAAA;IACA,gBAAA;IAEA,mBAAA;IACA,SAAA;EArGF;EAuGE;IACE,UAAA;EArGJ;EAyGA;IACE,qBAAA;EAvGF;AACF;AA0GA;EACE;IACE,eAAA;EAxGF;EA2GA;IACE,sBAAA;EAzGF;EA4GA;IACE,qBAAA;EA1GF;AACF","sourcesContent":[".details_containers_pgmpartner {\n  overflow: hidden;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(100vh - 66px);\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: transparent;\n  }\n\n  scrollbar-width: none;\n\n  .partnerContainer {\n    width: 100%;\n    display: flex;\n  }\n\n  .partnerContainerleft {\n    width: 20%;\n  }\n\n  .pgmlist_buttons_container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin: 0;\n    border-bottom: 0px;\n}\n\n  .partnerContainerright {\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 66px);\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n    scrollbar-width: none;\n  }\n \n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n\n  .header_border>img {\n    margin: 0.9rem 1rem;\n  }\n\n  .header_border>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n\n  .pgmlist_buttons {\n    display: flex;\n    width: 98%;\n    margin: 1rem auto;\n    gap: 1rem;\n    border-bottom: 1px solid #c1c6d0;\n  }\n\n  .Pgmlist_pending {\n    width: 15%;\n    height: 40px;\n    left: 299px;\n    top: 122px;\n    background: #0c3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n    color: #ffffff;\n  }\n\n  .pgmlist_Approved {\n    width: 15%;\n    height: 40px;\n    background: #e5f0ff;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7c87a1;\n    border: none;\n  }\n\n  .pgmlist_Add {\n    width: 15%;\n    height: 40px;\n    background: #e5f0ff;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7c87a1;\n    border: none;\n  }\n\n  .Partner_para_four_span {\n    width: 29px;\n    height: 29px;\n    background: #1445a4;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    border-radius: 50%;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  .security-container {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .security-line {\n    width: 100%;\n    margin: 10px 0;\n    border-top: 1px solid #BCC6D7;\n  }\n  \n  .security-text {\n    background-color: #fff;\n    padding: 0 10px;\n    color: #52443B;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.10000000149011612px;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .personalino-container {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .personalino-line {\n    width: 100%;\n    margin: 10px 0;\n    border-top: 1px solid #BCC6D7;\n  }\n  \n  .personalino-text {\n    background-color: #fff;\n    padding: 0 10px;\n    color: #52443B;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.10000000149011612px;\n    text-align: center;\n    white-space: nowrap;\n  }\n\n  .Partner_para_four_paragraphs {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #9CA8C0;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 0rem;\n  }\n\n  .Partner_para_four_spans {\n    width: 29px;\n    height: 29px;\n    background: #9CA8C0;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    border-radius: 50%;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n\n  .Partner_para_four_paragraph {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 0rem;\n  }\n\n  .Partner_para_fours_child {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .activeAddnew {\n    width: fit-content;\n    left: 299px;\n    top: 122px;\n    background: #0C3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    border: none;\n    color: #ffffff;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  .Partner_para_four {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem;\n    width: 98%;\n    background: #eff6ff;\n    align-items: center;\n    text-align: center;\n    padding: 0.8rem 0rem;\n  }\n\n  .Partner_para_fours {\n    display: flex;\n    gap: 50px;\n    align-items: center;\n    text-align: center;\n    padding: 0rem 0.4rem;\n  }\n\n  p {\n    background: none;\n  }\n\n  .personal_information{\n    width: 98%;\n    margin: 1rem;\n  }\n\n  .personal_information>img {\n    width: 95%;\n    margin: 1rem;\n  }\n\n  .personal_info_container {\n    width: 98%;\n    margin: auto;\n    display: flex;\n    margin-bottom: 1rem;\n  }\n\n  .personal_info_left {\n    width: 15%;\n    display: flex;\n    justify-content: center;\n    margin: 1rem 0rem;\n    padding: 1rem 0rem;\n  }\n\n  .personal_info_right {\n    width: 85%;\n  }\n\n  .loginthirdpara {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 33%;\n  }\n\n  .personal_inforight_security{\n    display: flex;\n    gap: 20px;\n\n    .loginthirdpara-security{\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 50%;\n  \n      .security-input-select{\n        width: 100% !important;\n      }\n    }\n  }\n\n  .input-wrapper {\n    position: relative;\n    width: 100%;\n\n    .error-text{\n      color: red;\n    }\n  }\n\n  .input-wrapper-addpartner-answers {\n    position: relative;\n    width: 100%;\n  }\n\n  .profile-plus-icons {\n    margin: 0rem 2rem;\n    position: relative;\n    z-index: 2;\n    top: -1rem;\n  }\n\n  .phonenumber::placeholder {\n    margin: 0rem 1rem !important;\n  }\n\n  .phonenumber {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    width: 98%;\n    height: 3.4rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    cursor: pointer;\n  }\n   #message{\n    text-align: left;\n    margin-left: 15px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: red;\n    max-width: 250px;\n   }\n  .react-tel-input .country-list {\n    margin: 10px 0 10px -15px;\n}\n\n.select-group{\n  width: 100% !important;\n}\n\n  input, .select-group {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    width: 100%;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n\n  .phone_input {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n  }\n\n  .number_inp {\n    border: none;\n    height: 3rem;\n    outline: none;\n    padding: 0;\n    margin-left: 13px;\n    width: 100%;\n  }\n\n  .react-tel-input .form-control {\n    border-radius: 6px;\n    position: relative;\n    width: 60px;\n    height: 3.3rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 0.5rem;\n    color: #10132e;\n    cursor: pointer;\n    border: none;\n    background-color: white;\n  }\n\n  .phone_bar {\n    margin-left: 23px;\n    margin-bottom: 3px;\n    font-size: 19px;\n  }\n\n  .react-tel-input .flag-dropdown {\n    border-right: none !important;\n    background-color: white;\n    border: none !important;\n    height: 3.3rem;\n  }\n\n  .react-tel-input .selected-flag {\n    width: 17px !important;\n    padding: 0 !important;\n  }\n\n  .react-tel-input .selected-flag .arrow {\n    display: none;\n  }\n\n  .react-tel-input {\n    border-radius: 6px;\n    position: relative;\n    width: 45px;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    cursor: pointer;\n  }\n\n  .input_textarea {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    width: 98%;\n    height: 3.4rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n\n  .pass-icon {\n    position: absolute;\n    top: 25%;\n    right: 10px;\n    color: #0C3688;\n    cursor: pointer;\n  }\n\n  .date-icon {\n    position: relative;\n    z-index: 2;\n    top: -2.8rem;\n    left: -2rem;\n    display: flex;\n    justify-content: end;\n    float: right !important;\n    cursor: pointer;\n  }\n\n  .phone-icons {\n    position: relative;\n    z-index: 2;\n    top: 3.2rem;\n    left: 0rem;\n    display: flex;\n    justify-content: end;\n    cursor: pointer;\n    float: right;\n  }\n\n  .enroll_select{\n    position: absolute;\n    top: 0px;\n    z-index: 99;\n    left: 1.6em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n\n  label {\n    position: absolute;\n    top: -10px;\n    z-index: 99;\n    left: 1.6em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n\n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n\n  .partners_five_para {\n    width: 98%;\n    margin: 1rem auto;\n  }\n\n  select {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    margin: 0px !important;\n    line-height: 6ex;\n    width: 100%;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n\n  .details_containers_pgmpartner select {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 100%;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n\n  .multiselect_partner {\n    width: 100%;\n  }\n\n  .multiselect_partner fieldset {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n  }\n\n  .multiple_select {\n    height: 54.4px;\n  }\n\n  .multiselect_input {\n    min-width: 80% !important;\n  }\n\n  .personal_inforight_inside {\n    display: flex;\n    margin-top: 1.5rem;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .Button_nexts .button_nextPartner {\n    width: 16%;\n    height: 40px;\n    background: #0c3688;\n    box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);\n    border-radius: 8px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 27px;\n    text-align: center;\n    color: #ffffff;\n    border: none;\n    margin: 1rem 2rem;\n    margin-bottom: 4rem;\n  }\n\n  .button_nextPartner:disabled {\n    width: 16%;\n    height: 40px;\n    background: #4d6698;\n    box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);\n    border-radius: 8px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 27px;\n    text-align: center;\n    color: #ffffff;\n    border: none;\n    margin: 1rem;\n    margin-bottom: 4rem;\n  }\n\n  .user-profile {\n    cursor: cell;\n  }\n\n  .Securityquestion_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    margin: 1rem 2rem;\n    color: #32363f;\n  }\n\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .personal_inforight_inside_next {\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n}\n\n.pass-flex{\n  display: flex;\n  width: 50%;\n  gap: 20px;\n}\n\n\n@media screen and (max-width:768px) {\n  .details_containers_pgmpartner .partnerContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .pass-flex{\n    display: flex;\n    width: 100%;\n  }\n\n  .details_containers_pgmpartner .personal_inforight_security .loginthirdpara-security{\n    width: 100%;\n  }\n\n  .personal_inforight_security{\n    flex-direction: column;\n  }\n\n  .loginthirdpara{\n    width: 100% !important;\n  }\n\n  .personal_info_right{\n    width: 98% !important;\n  }\n\n  .details_containers_pgmpartner .partnerContainerleft {\n    width: 100%;\n  }\n\n  .partnerContainerright {\n    width: 100% !important;\n    overflow-y: scroll !important;\n    overflow-x: hidden !important;\n    height: 100% !important;\n  }\n\n  .details_containers_pgmpartner {\n    overflow: scroll;\n    height: 100vh;\n  }\n\n  .details_containers_pgmpartner .pgmlist_buttons {\n    display: flex;\n    width: 95%;\n    margin: 1rem;\n    flex-wrap: wrap;\n    gap: 1rem;\n    border-bottom: 1px solid #c1c6d0;\n  }\n\n  .details_containers_pgmpartner .activeAddnew {\n    width: 100%;\n    height: 40px;\n    left: 299px;\n    top: 122px;\n    background: #0C3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n    color: #ffffff;\n    text-decoration: none;\n  }\n\n  .details_containers_pgmpartner .Partner_para_fours {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n    flex-wrap: wrap;\n    text-align: center;\n    padding: 0rem 0.4rem;\n    gap: 1rem;\n  }\n\n  .details_containers_pgmpartner .personal_info_container {\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .details_containers_pgmpartner .personal_info_left {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .details_containers_pgmpartner .personal_inforight_inside {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n    // flex-wrap: wrap;\n    align-items: start;\n  }\n\n  .details_containers_pgmpartner .input-wrapper-addpartner-answers {\n    position: relative;\n  }\n\n  .personal_inforight_inside_next {\n    justify-content: center !important;\n  }\n\n  .partnerContainer {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .partnerContainerleft {\n    width: 100% !important;\n  }\n\n  .partnerContainerright {\n    width: 100% !important;\n    // height: 50vh !important;\n  }\n\n  .pgmlistmain {\n    width: 100% !important;\n    height: 100vh;\n    background: #ffffff;\n  }\n\n  .pgmlist_container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .pgmlist_buttons_container .pgmlist_buttons .pgmlist_Approved, .activeAddnew {\n    width: 46% !important;\n  }\n\n  .activeAddnew {\n    width: 46% !important;\n  }\n}\n\n@media screen and (max-width:1024px) and (min-width:481px) {\n  .details_containers_pgmpartner .personal_inforight_inside {\n    display: flex;\n    margin-top: 1rem;\n    // flex-wrap: wrap;\n    align-items: center;\n    gap: 1rem;\n\n    .loginthirdpara{\n      width: 45%;\n    }\n  }\n\n  .Partner_para_fours {\n    width: 95% !important;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .personal_inforight_inside {\n    flex-wrap: wrap;\n  }\n\n  .pass-flex{\n    flex-direction: column;\n  }\n\n  .button_nextPartner{\n    width: 90% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
